import { ContributorGroupType } from '@/features/contributorGroups/constants'
import { OfferBookingStatus } from '@eapproval/offer-shared'
import { OfferStage, RoleInOffer } from '..'
import { getStage } from '../../helpers'

export const offerBookingGroupPolicyType = {
  BOOKING_GENERAL_INFO: 'BOOKING_GENERAL_INFO',
  BOOKING_SUPPORT_DOCUMENT: 'BOOKING_SUPPORT_DOCUMENT',
  BOOKING_ADDITIONAL_SUPPORT_DOCUMENT: 'BOOKING_ADDITIONAL_SUPPORT_DOCUMENT',
  BOOKING_COMMERCIAL_CUSTOMER_RIGHTS: 'BOOKING_COMMERCIAL_CUSTOMER_RIGHTS',
  BOOKING_COMMERCIAL_ITEMS: 'BOOKING_COMMERCIAL_ITEMS',
  BOOKING_SUB_SYSTEM: 'BOOKING_SUB_SYSTEM',
  BOOKING_APPROVAL: 'BOOKING_APPROVAL',
  BOOKING_HANDOVER_FORM: 'BOOKING_HANDOVER_FORM',

  //Specific
  BOOKING_WBS_NUMBER: 'BOOKING_WBS_NUMBER',
  BOOKING_SO_NUMBER: 'BOOKING_SO_NUMBER',
  BOOKING_CUSTOMER_PO: 'BOOKING_CUSTOMER_PO',
  BOOKING_CONFIRMATION_DOCUMENT: 'BOOKING_CONFIRMATION_DOCUMENT',
  BOOKING_COST_SHEET: 'BOOKING_COST_SHEET',
  BOOKING_APPROVAL_REMARK: 'BOOKING_APPROVAL_REMARK',
  BOOKING_CONFIRM_HANDOVER_FORM: 'BOOKING_CONFIRM_HANDOVER_FORM',
}

const allTechnicalEditingRole = [
  RoleInOffer.INITIATOR,
  RoleInOffer.CREATOR,
  RoleInOffer.DEPT_USER,
  RoleInOffer.TEAM_ASSISTANT,
]

export const offerBookingGroupPolicies = {
  [offerBookingGroupPolicyType.BOOKING_GENERAL_INFO]: {
    view: true,
    edit: ({ role, userGroup = '', isFreeze = false, offerStatus }) => {
      return (
        (allTechnicalEditingRole.includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER) &&
        !isFreeze &&
        getStage(offerStatus) === OfferStage.BOOKING
      )
    },
  },
  [offerBookingGroupPolicyType.BOOKING_SUPPORT_DOCUMENT]: {
    view: true,
    edit: ({ role, offerStatus }) =>
      allTechnicalEditingRole.includes(role) &&
      [OfferBookingStatus.BOOKING_DRAFT, OfferBookingStatus.BOOKING_REJECTED].includes(offerStatus),
  },
  [offerBookingGroupPolicyType.BOOKING_ADDITIONAL_SUPPORT_DOCUMENT]: {
    view: true,
    edit: ({ role, userGroup = '', offerStatus }) =>
      (allTechnicalEditingRole.includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER) &&
      [OfferBookingStatus.BOOKING_COMPLETED].includes(offerStatus),
  },
  [offerBookingGroupPolicyType.BOOKING_COMMERCIAL_CUSTOMER_RIGHTS]: {
    view: true,
    edit: ({ role, userGroup, offerStatus }) =>
      (allTechnicalEditingRole.includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER) &&
      [OfferBookingStatus.BOOKING_DRAFT, OfferBookingStatus.BOOKING_REJECTED].includes(offerStatus),
  },
  [offerBookingGroupPolicyType.BOOKING_COMMERCIAL_ITEMS]: {
    view: true,
    edit: ({ role, userGroup, isFreeze = false, offerStatus }) =>
      (allTechnicalEditingRole.includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER) &&
      !isFreeze &&
      getStage(offerStatus) === OfferStage.BOOKING,
  },

  [offerBookingGroupPolicyType.BOOKING_SUB_SYSTEM]: {
    edit: ({ role, isFreeze = false, userGroup, offerStatus }) =>
      (allTechnicalEditingRole.includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER) &&
      !isFreeze &&
      getStage(offerStatus) === OfferStage.BOOKING,
  },

  [offerBookingGroupPolicyType.BOOKING_APPROVAL]: {
    edit: ({ role, isFreeze = false, userGroup, offerStatus }) =>
      (allTechnicalEditingRole.includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER) &&
      [OfferBookingStatus.BOOKING_DRAFT, OfferBookingStatus.BOOKING_REJECTED].includes(offerStatus),
  },

  [offerBookingGroupPolicyType.BOOKING_WBS_NUMBER]: {
    edit: ({ userGroup }) => userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER,
  },
  [offerBookingGroupPolicyType.BOOKING_SO_NUMBER]: {
    edit: ({ role, userGroup }) =>
      [RoleInOffer.TEAM_ASSISTANT].includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER,
  },
  [offerBookingGroupPolicyType.BOOKING_CUSTOMER_PO]: {
    edit: ({ role, userGroup }) =>
      allTechnicalEditingRole.includes(role) || userGroup === ContributorGroupType.COMMERCIAL_PROJECT_MANAGER,
  },

  [offerBookingGroupPolicyType.BOOKING_CONFIRMATION_DOCUMENT]: {
    edit: ({ role, offerStatus }) =>
      [RoleInOffer.INITIATOR, RoleInOffer.CREATOR, RoleInOffer.DEPT_USER, RoleInOffer.TEAM_ASSISTANT].includes(role) &&
      [
        OfferBookingStatus.BOOKING_DRAFT,
        OfferBookingStatus.BOOKING_REJECTED,
        OfferBookingStatus.BOOKING_COMPLETED,
      ].includes(offerStatus),
  },

  [offerBookingGroupPolicyType.BOOKING_COST_SHEET]: {
    edit: ({ role, offerStatus }) =>
      [RoleInOffer.INITIATOR, RoleInOffer.CREATOR, RoleInOffer.DEPT_USER, RoleInOffer.TEAM_ASSISTANT].includes(role) &&
      [OfferBookingStatus.BOOKING_DRAFT, OfferBookingStatus.BOOKING_REJECTED].includes(offerStatus),
  },
  [offerBookingGroupPolicyType.BOOKING_CONFIRM_HANDOVER_FORM]: {
    edit: ({ allRoles, offerStatus }) =>
      allRoles.includes(RoleInOffer.BOOKING_MANAGER) &&
      [OfferBookingStatus.BOOKING_DRAFT, OfferBookingStatus.BOOKING_REJECTED].includes(offerStatus),
  },
  [offerBookingGroupPolicyType.BOOKING_HANDOVER_FORM]: {
    edit: ({ allRoles, offerStatus }) =>
      [OfferBookingStatus.BOOKING_DRAFT, OfferBookingStatus.BOOKING_REJECTED].includes(offerStatus),
  },
}
